<template>
  <div>
    <!--   订单待入金 -->
    <baseBreadcrumb :page="$t('message.orderPendingDeposit')" :menu="$t('message.orderForm')" />
    <orderMain status="30" />
  </div>
</template>
<script>
import orderMain from "@/components/order/baseTable/index.vue";
export default {
  components: {
    orderMain,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped></style>